<script lang="ts" setup>
import type { ITableColumnsOptions } from '@modules/tables/types';
import VButton from '@components/buttons/VButton/VButton.vue';
import VIconButton from '@components/buttons/VIconButton/VIconButton.vue';
import VCard from '@components/card/VCard/VCard.vue';
import ChangeEmployeeStatus from '@modules/employees/components/ChangeEmployeeStatus/ChangeEmployeeStatus.vue';
import { EMPLOYEES_LIST_PERMISSIONS, TRANSLATION_GROUP_EMPLOYEES_LIST } from '@modules/employees/constants';
import { useEmployeesListQuery } from '@modules/employees/queries';
import { EMPLOYEES_CREATE_ROUTE_NAME } from '@modules/employees/submodules/create/constants';
import { EMPLOYEES_EDIT_ROUTE_NAME } from '@modules/employees/submodules/edit/constants';
import VTable from '@modules/tables/components/VTable/VTable.vue';
import { useTableData } from '@modules/tables/composables';

const {
  tableState,
  data,
  isLoading,
  isFetching,
  updateTableState,
  refreshTableData,
} = useTableData(useEmployeesListQuery);

const columnOptions: ITableColumnsOptions = {
  name: {
    defaultMobilePreview: true,
  },
};
</script>

<template>
  <VCard v-data-qa-auto-id="'EmployeesListPage'" type="table">
    <VTable
      :data="data"
      :state="tableState"
      :loading="isLoading"
      :is-fetching="isFetching"
      :title-t-path="$getTPath(TRANSLATION_GROUP_EMPLOYEES_LIST, 'HEADER')"
      :columns-options="columnOptions"
      @state-update="updateTableState"
      @refresh="refreshTableData"
    >
      <template #recordAction="{ listItem }">
        <VIconButton
          v-if="$hasPermission(EMPLOYEES_LIST_PERMISSIONS.EDIT)"
          icon="pi-id-card"
          :to="{
            name: EMPLOYEES_EDIT_ROUTE_NAME,
            params: {
              id: String(listItem.id),
            },
          }"
        />
        <ChangeEmployeeStatus
          v-if="$hasPermission(EMPLOYEES_LIST_PERMISSIONS.BAN)"
          :list-item="listItem"
        />
      </template>
      <template
        v-if="$hasPermission(EMPLOYEES_LIST_PERMISSIONS.CREATE)"
        #footerButtons
      >
        <VButton
          :label="$getTranslation(TRANSLATION_GROUP_EMPLOYEES_LIST, 'ADD')"
          :to="{ name: EMPLOYEES_CREATE_ROUTE_NAME }"
        />
      </template>
    </VTable>
  </VCard>
</template>
